/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InsurancePeriod } from './insurancePeriod';
import { PreviousMotorVehicleElementaryProduct } from './previousMotorVehicleElementaryProduct';

/**
 * Represents a motor vehicle insurance product.   (german: Kfz Versicherung)   (bipro-kraftfahrt::KfzVersicherung)
 */
export interface PreviousMotorVehicleProduct {
  /**
   * Technical discriminator for the concrete product type.
   */
  productType: string;
  insurancePeriod?: InsurancePeriod;
  /**
   * Elementary products. Lowest level in product hierarchy.  Smallest unit for price calculation, e.g. coverage \"HAF\", \"TEI\", \"VOL\"   (bipro-produktmodell::Elementarprodukt)
   */
  elementaryProducts?: Array<PreviousMotorVehicleElementaryProduct>;
}
